import { api } from '@/lib/api';

export interface LembreteRapidoAnexo {
  id: string;
  lembreteRapidoId: string;
  fileName: string;
  originalName: string;
  fileSize: number;
  mimeType: string;
  url: string;
  createdAt: string;
}

export interface QuickLembrete {
  id: string;
  titulo: string;
  descricao: string;
  dataHora: string;
  concluido: boolean;
  userId: string;
  createdAt: string;
  updatedAt: string;
  anexos: LembreteRapidoAnexo[];
}

function mapRow(
  raw: QuickLembrete & { anexos?: LembreteRapidoAnexo[] }
): QuickLembrete {
  return {
    ...raw,
    anexos: Array.isArray(raw.anexos) ? raw.anexos : [],
  };
}

export const quickLembretesService = {
  async list(): Promise<QuickLembrete[]> {
    const res = await api.get<{ success: boolean; data: { lembretes: unknown[] } }>('/quick-lembretes');
    const list = res.data.data?.lembretes;
    if (!Array.isArray(list)) return [];
    return list.map((l) => mapRow(l as QuickLembrete));
  },

  async create(body: { titulo: string; descricao: string; dataHora: string }): Promise<QuickLembrete> {
    const res = await api.post<{ success: boolean; data: { lembrete: QuickLembrete } }>(
      '/quick-lembretes',
      body
    );
    return mapRow(res.data.data.lembrete);
  },

  async update(
    id: string,
    patch: Partial<Pick<QuickLembrete, 'titulo' | 'descricao' | 'dataHora' | 'concluido'>>
  ): Promise<QuickLembrete> {
    const payload: Record<string, unknown> = { ...patch };
    const res = await api.patch<{ success: boolean; data: { lembrete: QuickLembrete } }>(
      `/quick-lembretes/${encodeURIComponent(id)}`,
      payload
    );
    return mapRow(res.data.data.lembrete);
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/quick-lembretes/${encodeURIComponent(id)}`);
  },

  async uploadAnexo(lembreteId: string, file: File): Promise<LembreteRapidoAnexo> {
    const fd = new FormData();
    fd.append('file', file);
    const res = await api.post<{
      success: boolean;
      data: { anexo: LembreteRapidoAnexo };
    }>(`/quick-lembretes/${encodeURIComponent(lembreteId)}/anexos`, fd);
    return res.data.data.anexo;
  },

  async removeAnexo(lembreteId: string, anexoId: string): Promise<void> {
    await api.delete(
      `/quick-lembretes/${encodeURIComponent(lembreteId)}/anexos/${encodeURIComponent(anexoId)}`
    );
  },
};

export const MAX_ANEXOS = 10;
export const MAX_ANEXO_BYTES = 10 * 1024 * 1024;
